import { useMedia } from 'react-use';

import { SCREEN_SIZE_BREAKPOINT } from '@/constants';

export function useBreakpoint(
    breakpoint: 'xxs' | 'xs' | 'sm' | 'md' | 'lg',
    mode: 'above' | 'below',
) {
    if (!SCREEN_SIZE_BREAKPOINT[breakpoint]) {
        throw new Error(`Unknown breakpoint: ${breakpoint}`);
    }

    const breakpointPxValue = SCREEN_SIZE_BREAKPOINT[breakpoint];
    const mediaQuery =
        mode === 'above'
            ? `(min-width: ${breakpointPxValue + 1}px)`
            : `(max-width: ${breakpointPxValue}px)`;

    return useMedia(mediaQuery, false);
}
